/** 下载中心 — 产品资料与宣传册 */

import { company } from './siteConfig'

export const downloadPageHero = {
  tone: 'system',
  icon: 'software',
  eyebrow: 'Downloads',
  title: '下载中心',
  desc: '产品资料、企业宣传册与演示视频，一站式获取',
  image: '/images/pdf-pages/gaoren-01.png',
  photoFrame: 'light',
}

export const downloadCategories = [
  { id: 'brochure', label: '企业宣传册', icon: 'book' },
  { id: 'system', label: '系统类产品', icon: 'cloud' },
  { id: 'education', label: '教育类产品', icon: 'school' },
  { id: 'robot', label: '机器人产品', icon: 'robot' },
  { id: 'video', label: '产品视频', icon: 'video' },
]

export const downloadItems = [
  {
    id: 'brochure-2026',
    category: 'brochure',
    title: '天津高仁科技 2026 企业宣传册',
    desc: '完整产品介绍、案例效果图与客户名录，PDF 高清版',
    format: 'PDF',
    size: '约 15 MB',
    url: company.brochurePdf,
    cover: '/images/pdf-pages/gaoren-01.png',
    featured: true,
  },
  {
    id: 'vision-training-schedule',
    category: 'education',
    title: '工业视觉检测与维护专项培训安排表（10天）',
    desc: '2026年8月23日—11月1日周末授课安排，含硬件、通讯、软件、机器人协作与综合考核',
    format: 'DOCX',
    size: '培训资料',
    url: '/brochure/vision-training-schedule-10day.docx',
    cover: '/images/pdf-pages/gaoren-21.png',
  },
  {
    id: 'smart-power-intro',
    category: 'system',
    title: '智慧用电云平台产品介绍',
    desc: '用电监测、能耗分析、报表与报警等功能模块说明',
    format: 'PDF',
    size: '在线浏览',
    url: company.brochurePdf,
    cover: '/images/systems/power-curve.png',
  },
  {
    id: 'smart-pv-intro',
    category: 'system',
    title: '智慧光伏云平台产品介绍',
    desc: '光伏大屏、逆变器数据、网关与报警中心功能概览',
    format: 'PDF',
    size: '在线浏览',
    url: company.brochurePdf,
    cover: '/images/systems/pv-dashboard.png',
  },
  {
    id: 'education-catalog',
    category: 'education',
    title: '职业教育实训装备产品目录',
    desc: '涵盖产线实训、机器人技能、传感器、电工电子等教学仪器',
    format: 'PDF',
    size: '在线浏览',
    url: company.brochurePdf,
    cover: '/images/pdf-pages/gaoren-21.png',
  },
  {
    id: 'robot-catalog',
    category: 'robot',
    title: '机器人与 AGV 产品手册',
    desc: '人型机器人、机器狗、AGV、复合机器人定制方案',
    format: 'PDF',
    size: '在线浏览',
    url: company.brochurePdf,
    cover: '/images/brochure/img-p4-18.jpeg',
  },
  {
    id: 'automation-catalog',
    category: 'robot',
    title: '非标自动化产线案例集',
    desc: '自动化产线定制、原创工业级产品与案例效果图',
    format: 'PDF',
    size: '在线浏览',
    url: company.brochurePdf,
    cover: '/images/pdf-pages/gaoren-31.png',
  },
  {
    id: 'company-video',
    category: 'video',
    title: '企业介绍视频',
    desc: '天津高仁科技核心能力与典型应用场景',
    format: '视频',
    size: '在线播放',
    url: '#',
    cover: '/images/hero-bottom-lineup.png',
    isVideo: true,
  },
  {
    id: 'training-video',
    category: 'video',
    title: '实训平台演示视频',
    desc: '智能制造产线与工业机器人技能实训平台运行演示',
    format: '视频',
    size: '在线播放',
    url: '#',
    cover: '/images/competition-training.png',
    isVideo: true,
  },
]

export function getDownloadsByCategory(categoryId) {
  if (!categoryId || categoryId === 'all') return downloadItems
  return downloadItems.filter((item) => item.category === categoryId)
}
